import { render, staticRenderFns } from "./GfStatement.vue?vue&type=template&id=7f2ba3b8"
import script from "./GfStatement.vue?vue&type=script&lang=js"
export * from "./GfStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports